/**
 * Live manifest list for a modem's continuous-capture artifacts (#252):
 * `devices/{deviceId}/known_modems/{imei}/artifacts` — mirrors the
 * execution-scoped subscription in useExecutionLogs.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query, limit as qlimit } from 'firebase/firestore';
import { db } from '@/config/firebase';

export function useModemArtifacts(deviceId: string | null | undefined, modemImei: string | null | undefined, max = 200) {
  const [artifacts, setArtifacts] = useState<any[]>([]);
  useEffect(() => {
    if (!deviceId || !modemImei) { setArtifacts([]); return; }
    const unsub = onSnapshot(
      query(collection(db, 'devices', deviceId, 'known_modems', modemImei, 'artifacts'), orderBy('uploadedAt', 'desc'), qlimit(max)),
      (snap) => setArtifacts(snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) }))),
      (err) => console.warn('Modem artifact subscription error:', err),
    );
    return () => unsub();
  }, [deviceId, modemImei, max]);
  return artifacts;
}
